import t_19_2320_colorized from './KZ.T.19.2320.svg'
import t_19_2320 from './KZ.T.19.2320 black.svg'

export default [
  t_19_2320_colorized,
  t_19_2320,
]
